import { addRecurso } from './addRecurso'
import { deleteRecurso } from './deleteRecurso'
import { editRecurso } from './editRecurso'
import { getAll } from './getRecursos'
import { get } from './getRecurso'

export const recursoService = {
  add: addRecurso,
  delete: deleteRecurso,
  edit: editRecurso,
  getAll,
  get,
}
